import {Component, Input} from '@angular/core';
import {SwiperOptions} from 'swiper';
import {ProductionSiteDTO} from '@rsp/models/dto/tenants-details.dto';
import {RspEndpointsService} from '@rsp/shared/services/rest/rsp-endpoints.service';
import {DefaultImages} from '@rsp/shared/util/default-images';


@Component({
  selector: 'rsp-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent {

  public defaultImage: DefaultImages = DefaultImages.PRODUCTION_SITE;

  public config: SwiperOptions = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    grabCursor: true,
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },

  };

  @Input() public productionSites: ProductionSiteDTO[];

  public index;

  constructor(private rspEndpointsService: RspEndpointsService) {

  }

  public getPicturePath(id: number): string {
    return this.rspEndpointsService.createUrlWithQueryParameters(RspEndpointsService.GET_PRODUCTION_SITE_IMAGE, (qs) => {
      qs.push('productionSiteId', id);
    });
  }

  public hasKennzahlen(site: ProductionSiteDTO): boolean {
    return site.keyValuess.length > 0 && site.keyValuess.reduce((acc: boolean, cur) => {

      if (cur.dayMonthYearValues.reduce((acc2, cur2) => {
        acc2 += cur2;
        return acc2;
      }, 0) === 0) {
        acc = false;
      }

      return acc;
    }, true);
  }


}
